import { useEffect, useState } from 'react';

/**
 * Note: pointer: fine is used to also capture a few Android devices that support
 * hover as a long click.
 */
const HOVERABLE_DEVICE_QUERY = '(hover: hover) and (pointer: fine)';

/**
 * Checks to see if the browser supports hover interactions or not.
 *
 * Where possible prefer CSS to handle hover state interactions. This
 * hook is useful when you need to intervene with results of useHover.
 *
 * @returns true if the browser supports hover interactions
 */
export function useHoverableDevice() {
  const [hoverable, setHoverable] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(HOVERABLE_DEVICE_QUERY);
    setHoverable(mediaQuery.matches);

    function updateHoverable(e: MediaQueryListEvent) {
      setHoverable(e.matches);
    }

    mediaQuery.addEventListener('change', updateHoverable);

    return () => mediaQuery.removeEventListener('change', updateHoverable);
  }, []);

  return hoverable;
}
